import request from '@/libs/request';

export const QueryArticleComments = (data = {}) => request('QueryArticleComments', data); // 查询评论

export const AuditArticleComment = (data = {}) => request('AuditArticleComment', data); // 操作评论
